import React from 'react';
import Typography from "@mui/material/Typography";
import Spacer from "../../Spacer";
import './Terms.scss';

const PrivacyPolicy = () => {
    return (
        <div className="terms-content">
            <Typography variant="h5" component="h1" gutterBottom>
                Privacy Policy
            </Typography>

            <Typography variant="body1">
                Aviani.org respects your privacy. This page explains what information we collect through the website,
                how we use it, and what happens to waitlist email addresses after launch.
            </Typography>
            <Spacer axis="vertical" size={20} />

            <section className="terms-section">
                <Typography variant="h6">1. Information We Collect</Typography>
                <Typography variant="body2">
                    We currently collect limited information that you provide directly, such as your email address when you join
                    the waitlist or contact us through the website.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18} />

            <section className="terms-section">
                <Typography variant="h6">2. How We Use Your Email</Typography>
                <Typography variant="body2">
                    If you join the waitlist, we use your email to send launch updates, product availability notices,
                    onboarding information, and occasional important product news related to the service. We do not sell your
                    email address to third parties.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18} />

            <section className="terms-section">
                <Typography variant="h6">3. How Emails Will Be Handled After Launch</Typography>
                <Typography variant="body2">
                    After launch, waitlist emails may be moved into our main product communications list so we can contact you about
                    access, account setup, product changes, and relevant service updates. If you do not want to continue receiving those
                    emails, you will be able to unsubscribe from marketing-style updates. We may still send essential service emails to
                    active users where necessary for account or product operations.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18} />

            <section className="terms-section">
                <Typography variant="h6">4. Data Storage and Retention</Typography>
                <Typography variant="body2">
                    We keep personal information only for as long as it is reasonably necessary to operate the waitlist, launch the
                    product, respond to inquiries, and meet legal or operational obligations. Information that is no longer needed may be
                    deleted or anonymized.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18} />

            <section className="terms-section">
                <Typography variant="h6">5. Data Controller</Typography>
                <Typography variant="body2">
                    The personal data collected through this website is associated with and managed by Investitum. For privacy-related
                    questions, requests, or notices, you can contact us at info@aviani.org.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18} />

            <section className="terms-section">
                <Typography variant="h6">6. Third-Party Services</Typography>
                <Typography variant="body2">
                    We may use third-party providers to help manage email delivery, analytics, hosting, or product operations. Those
                    providers only receive the information needed to perform their services and are expected to protect it appropriately.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18} />

            <section className="terms-section">
                <Typography variant="h6">7. Your Choices</Typography>
                <Typography variant="body2">
                    You can contact us if you want to ask about the information we hold about you, request corrections, or request that
                    we delete your waitlist email where applicable.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18} />

            <section className="terms-section">
                <Typography variant="h6">8. Contact</Typography>
                <Typography variant="body2">
                    If you have questions about this Privacy Policy or how your information is handled, please email info@aviani.org or
                    use the contact page on this website.
                </Typography>
            </section>
            <Spacer axis="vertical" size={20} />
        </div>
    );
};

export default PrivacyPolicy;